import {HttpErrorResponse, HttpResponseBase} from "@angular/common/http";
import {TypetValideringsresultatModell} from "felles-ng2/tjenester/ressurser/ng2HttpKlientTilleggstyper";

/**
 * Http responskoder.
 *
 * Inklusive feilkoder som benyttes av Lederplan server (se LederplanExceptionMapperBinder i javakoden).
 *
 * For håndtering av Http respons feil og identifisering av feiltype se `httpErrorResponseTyper.ts`.
 * Se også 'feilhåndtering.ts' for standard feilmeldinger for visse typer feil.
 */
export enum HttpResponskoder {
    //ok-koder
    OK = 200,

    //standard feil-koder
    /** Når ukjent URL er forespurt */
    UNAUTHORIZED = 401,
    NOT_FOUND = 404,
    REQUEST_TIMEOUT = 408,
    GONE = 410,
    EXPECTATION_FAILED = 417,
    TO_MANY_REQUESTS = 429,
    INTERNAL_SERVER_ERROR = 500,
    /** bla nginx throttling */
    SERVICE_UNAVAILABLE = 503,

    //feil-koder knyttet til Lederlan tjenester exception, se no.systemfabrikken.lederplan.infrastruktur.dropwizard.LederplanExceptionMapperBinder
    /** Ved ObjectNotFoundException (java) - når forespurt entitet ikke finnes i DB. */
    ObjectNotFoundException = GONE,
    /** Ved ValideringsfeilException (java) - når valideringskode i domenemodell sier at noe er feil.
     * {@link HttpErrorResponse#error} vil inneholde en {@link ValideringsresultatModell} som inneholder detaljer om valideringsfeilen.
     * Se også {@link TypetValideringsresultatModell} som gir støtte for å angi hvilken enum feilkodene stammer fra. */
    ValideringsfeilException = EXPECTATION_FAILED,
    /** Ved IkkeTilgangTilEntitetException (java) */
    IkkeTilgangTilEntitetException_møteIkkePublisert = 460,
    /** Ved IkkeTilgangTilEntitetException (java) */
    IkkeTilgangTilEntitetException_protokollIkkePublisert = 461,
    /** Ved IkkeTilgangTilEntitetException (java) */
    IkkeTilgangTilEntitetException_skjermet = 462,
    /** Ved IkkeTilgangTilEntitetException (java) */
    IkkeTilgangTilEntitetException_privat = 463,
    /** Ved IkkeTilgangTilEntitetException (java) */
    IkkeTilgangTilEntitetException_gruppetilgang = NOT_FOUND,
    /** Ved IkkeTilgangTilEntitetException (java) */
    IkkeTilgangTilEntitetException_ikkeSpesifisertÅrsak = NOT_FOUND,
}

/** Samling med responskoder som indikerer tilgangsfeil */
export const ikkeTilgangTilEntitetExceptions = [
    HttpResponskoder.IkkeTilgangTilEntitetException_møteIkkePublisert,
    HttpResponskoder.IkkeTilgangTilEntitetException_protokollIkkePublisert,
    HttpResponskoder.IkkeTilgangTilEntitetException_skjermet,
    HttpResponskoder.IkkeTilgangTilEntitetException_privat,
    HttpResponskoder.IkkeTilgangTilEntitetException_gruppetilgang,
    HttpResponskoder.IkkeTilgangTilEntitetException_ikkeSpesifisertÅrsak,
];

/** Returnerer sann dersom angitt respons har status på 400-tallet. */
export function erResponsStatus4XX(respons: HttpResponseBase){
    if (respons.status < 400) return false;
    if (respons.status >= 500) return false;
    return true;
}
